import { render, staticRenderFns } from "./Newsdetail.vue?vue&type=template&id=6b158312&scoped=true&"
import script from "./Newsdetail.vue?vue&type=script&lang=js&"
export * from "./Newsdetail.vue?vue&type=script&lang=js&"
import style0 from "./Newsdetail.vue?vue&type=style&index=0&id=6b158312&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b158312",
  null
  
)

export default component.exports